import Vue from 'vue';

export default class {
	constructor(parameters) {
		this.type = 'SET';
		this.params = parameters;
		this.oldData = undefined;
	}

	execute() {
		const {
			state,
			blockId,
			data,
		} = this.params;

		if (JSON.stringify(state.website.blocks[blockId]) === JSON.stringify(data)) {
			return false;
		}

		this.oldData = state.website.blocks[blockId];

		Vue.set(state.website.blocks, blockId, data);

		return true;
	}

	undo() {
		const {
			state,
			blockId,
		} = this.params;

		Vue.set(state.website.blocks, blockId, this.oldData);
	}
}
